import { winRateColors } from "@/util/constants.mjs";

export default {
  red: "#FF5859",
  turq: "#24E8CC",
  blue: "#49B4FF",
  blue2: "#222e47",
  yellow: "#F3CC57",
  gradient: {
    red: "linear-gradient(to right bottom, #e65152, #f56e6f);",
    blue: "linear-gradient(to right bottom, #399fe6, #90d1ff);",
    gold: "linear-gradient(to right bottom, #e6b866, #cc9335);",
  },
  ranks: {
    iron: {
      fill: "#817678",
      text: "#a29294",
      hsl: "348deg 6% 32%",
    },
    bronze: {
      fill: "#9F6347",
      text: "#b97452",
      hsl: "18deg 41% 39%",
    },
    silver: {
      fill: "#80989D",
      text: "#a2c1c7",
      hsl: "190deg 13% 56%",
    },
    gold: {
      fill: "#CD8837",
      text: "#f1a64e",
      hsl: "32deg 60% 51%",
    },
    platinum: {
      fill: "#1c91b6",
      text: "#14c0f5",
      hsl: "194deg 73% 41%",
    },
    emerald: {
      fill: "#519847",
      text: "#56d744",
      hsl: "113deg 36% 44%",
    },
    diamond: {
      fill: "#8141EB",
      text: "#9556ff",
      hsl: "263deg 81% 59%",
    },
    master: {
      fill: "#9D48E0",
      text: "#A952E5",
      hsl: "274deg 71% 58%",
    },
    grandmaster: {
      fill: "#D94444",
      text: "#ef4f4f",
      hsl: "0deg 66% 56%",
    },
    challenger: {
      fill: "#F4C874",
      text: "#F4C874",
      hsl: "39deg 85% 71%",
    },
    none: {
      fill: "var(--shade6)",
      text: "var(--shade3)",
    },
    wood: {
      fill: "#80554D",
      text: "#ac756a",
    },
    gladiator: {
      fill: "#D967E4",
      text: "#D967E4",
    },
  },
  damageType: {
    ad: "#FF5859",
    ap: "#7E89F7",
    tr: "#E4ECEE",
  },
  stats: {
    attackDamage: "#BD7E4D",
    abilityPower: "#9BFFF7",
    armor: "#F0705A",
    magicResist: "#CE8ED1",
    attackSpeed: "#F3C452",
    crit: "#CE3C42",
    critChance: "#CE3C42",
    mana: "#26C2F3",
    health: "#20995D",
  },
  abilities: {
    1: "var(--red)",
    2: "var(--turq)",
    3: "var(--blue)",
    4: "var(--yellow)",
  },
  runes: {
    domination: "#D94444",
    inspiration: "#49ABBA",
    precision: "#D9B66F",
    resolve: "#A1D486",
    sorcery: "#7F89F7",
  },
  championTiers: {
    tier1: "#FF5859",
    tier2: "#FF9417",
    tier3: "#49ABBA",
    tier4: "#3371A4",
    tier5: "#335375",
  },
  winrate: winRateColors,
  kda: {
    kda1less: "#828790",
    kda1to2: "#978D87",
    kda2to4: "#C4A889",
    kda4to6: "#DEAF78",
    kda6to10: "#E6A85F",
    kda10plus: "#FF9417",
    perfect: "#ffbe05",
  },
  grade: {
    "S+": "var(--subscriber-solid)",
    S: "var(--subscriber-solid)",
    "S-": "#49B4FF",
    "A+": "var(--turq)",
    A: "var(--turq)",
    "A-": "var(--turq)",
    "B+": "var(--turq)",
    B: "#9DD5D7",
    "B-": "#9DD5D7",
    "C+": "#DD7A7D",
    C: "#DD7A7D",
    "C-": "#DD7A7D",
    "D+": "#E4858F",
    D: "#F16F74",
    "D-": "var(--red)",
  },
  tier: {
    1: "#FF5859",
    2: "#FF9417",
    3: "#49ABBA",
    4: "#3371A4",
    5: "#335375",
  },
};
